import assetPath from '/app/packages/lebenslauf/articles/src/assets/edv-kenntnisse-im-lebenslauf-wie-du-deine-digitalen-faehigkeiten-praesentierst.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')